import React from 'react';
import AddHeader from '../../../../components/layout/header/add';
import Form from '../../../../components/molecules/forms';
import Button from '../../../../components/molecules/buttons';
import useAddRefund from './hooks';
import { SERVICE_REASON_OPTIONS } from '../../../../components/atoms/const';
import { DollarSign } from '../../../../components/atoms/icons';

function AddRefund() {
  const {
    navigateToLanding, addRequestLoad, formik, vm, state, client,
  } = useAddRefund();

  return (
    <div>
      <AddHeader
        primary={{ route: '/customer-support', title: 'Refund Request' }}
        title="Add Refund Request"
      />
      <form onSubmit={formik.handleSubmit}>
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-16 mb-4">Client Info</div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="clientName"
                placeholder="Client Name"
                label="Search or Choose A Client"
                options={client.list}
                value={formik.values.clientName}
                onChange={(e) => {
                  if (e) {
                    formik.setFieldValue('clientName', e);
                    formik.setFieldValue('vmId', null);
                  }
                }}
                onBlur={formik.handleBlur}
                disabled={client.load}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="vmId"
                placeholder="Vending Machine"
                label="Choose Vending Machine"
                isSearchable={false}
                options={vm.list}
                value={formik.values.vmId}
                onChange={(e) => {
                  if (e) {
                    formik.setFieldValue('vmId', e);
                  }
                }}
                onBlur={formik.handleBlur}
                isInvalid={!!formik.errors.vmId && formik.touched.vmId}
                errorMsg={formik.errors.vmId}
                disabled={!formik.values.clientName}
              />
            </div>
            {/* <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="clientName"
                placeholder="Client Name"
                label="Select or Choose A Client"
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.AsyncMode
                id="vmId"
                label="Vending Machine"
                placeholder="Choose Vending Machine"
                optionsFetcher={vm.optionsFetcher}
                inputValue={vm.inputValue}
                onChangeInput={(e) => vm.setInputValue(e)}
                onChangeSelected={(e) => {
                  if (e) formik.setFieldValue('vmId', e);
                }}
                selectedValue={formik.values.vmId}
                errorMsg={formik.errors.vmId}
                isInvalid={!!formik.errors.vmId && formik.touched.vmId}
                onBlur={formik.handleBlur}
              />
            </div> */}
          </div>
        </div>
        <div className="bg-stroke my-4" style={{ height: '7px' }} />
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-16 mb-4">Customer Info</div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="firstname"
                placeholder="Enter First Name"
                label="First Name"
                value={formik.values.firstname}
                errorMsg={formik.errors.firstname}
                isInvalid={!!formik.errors.firstname && formik.touched.firstname}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="lastname"
                placeholder="Enter Last Name"
                label="Last Name"
                value={formik.values.lastname}
                errorMsg={formik.errors.lastname}
                isInvalid={!!formik.errors.lastname && formik.touched.lastname}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="phoneNumber"
                placeholder="Enter Phone No."
                label="Phone No."
                value={formik.values.phoneNumber}
                errorMsg={formik.errors.phoneNumber}
                isInvalid={!!formik.errors.phoneNumber && formik.touched.phoneNumber}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="email"
                placeholder="Enter Email Address"
                label="Email Address"
                type="email"
                value={formik.values.email}
                errorMsg={formik.errors.email}
                isInvalid={!!formik.errors.email && formik.touched.email}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="streetAddress"
                placeholder="Enter Street Address"
                label="Street Address"
                value={formik.values.streetAddress}
                errorMsg={formik.errors.streetAddress}
                isInvalid={!!formik.errors.streetAddress && formik.touched.streetAddress}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="zipCode"
                placeholder="Enter Zip Code"
                label="Zip Code"
                type="number"
                value={formik.values.zipCode}
                errorMsg={formik.errors.zipCode}
                isInvalid={!!formik.errors.zipCode && formik.touched.zipCode}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="city"
                placeholder="Enter City"
                label="City"
                value={formik.values.city}
                errorMsg={formik.errors.city}
                isInvalid={!!formik.errors.city && formik.touched.city}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="state"
                placeholder="Enter State"
                label="State"
                options={state.list}
                disabled={state.load}
                value={formik.values.state}
                errorMsg={formik.errors.state}
                isInvalid={!!formik.errors.state && formik.touched.state}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  if (e) {
                    formik.setFieldValue('state', e);
                  }
                }}
                isSearchable={false}
              />
            </div>
          </div>
        </div>
        <div className="bg-stroke my-4" style={{ height: '7px' }} />
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-16 mb-4">Refund Info</div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.DefaultWithIcon
                id="requestAmount"
                placeholder="Enter Requested Amount"
                label="Requested Amount"
                value={formik.values.requestAmount}
                errorMsg={formik.errors.requestAmount}
                isInvalid={!!formik.errors.requestAmount && formik.touched.requestAmount}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="number"
                leftIcon={<DollarSign />}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="refundReason"
                placeholder="Choose Refund Reason"
                label="Refund Reason"
                isSearchable={false}
                options={SERVICE_REASON_OPTIONS}
                value={formik.values.refundReason}
                errorMsg={formik.errors.refundReason}
                isInvalid={!!formik.errors.refundReason && formik.touched.refundReason}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  if (e) {
                    formik.setFieldValue('refundReason', e);
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="bg-stroke mt-5 mb-4" style={{ height: '7px' }} />
        <div className="px-4 px-xl-5 d-flex justify-content-end pb-4">
          <div style={{ width: '200px', marginRight: '20px' }}>
            <Button.Default
              id="cancel"
              type="button"
              label="Cancel"
              size="lg"
              outline
              onClick={navigateToLanding}
            />
          </div>
          <Button.Default
            id="add"
            type="submit"
            label="Add"
            style={{ minWidth: 200 }}
            loading={addRequestLoad}
          />
        </div>
      </form>
    </div>
  );
}

export default AddRefund;
